import Inicio from '@/views/Inicio.vue'
// import Nosotros from '@/views/Nosotros.vue'
import Servicios from '@/views/servicios/Servicios.vue'
import GP12 from '@/views/servicios/GP12.vue'
import IncomingInspection from '@/views/servicios/IncomingInspection.vue'
import CS from '@/views/servicios/CS.vue'
import Retrabajo from '@/views/servicios/Retrabajo.vue'
import Sorteos from '@/views/servicios/Sorteos.vue'
// import Ensambles from '@/views/servicios/Ensambles.vue'
// import Clientes from '@/views/Clientes.vue'
// import Contacto from '@/views/Contacto.vue'
import AvisoDePrivacidad from '@/views/AvisoDePrivacidad.vue'


export default {
    get() {
        let routes = [
            {
                path: '/',
                name: 'inicio',
                component: Inicio
            },
            // {
            //     path: '/nosotros',
            //     component: Nosotros
            // },
            {
                path: '/servicios',
                component: Servicios
            },
            {
                path: '/servicios/gp12',
                component: GP12
            },
            {
                path: '/servicios/incoming-inspection',
                component: IncomingInspection
            },
            {
                path: '/servicios/cs1-cs2',
                component: CS
            },
            {
                path: '/servicios/retrabajo',
                component: Retrabajo
            },
            {
                path: '/servicios/sorteos',
                component: Sorteos
            },
            // {
            //     path: '/servicios/ensambles',
            //     component: Ensambles
            // },
            // {
            //     path: '/clientes',
            //     component: Clientes
            // },
            // {
            //     path: '/contacto',
            //     component: Contacto
            // },
            {
                path: '/aviso-de-privacidad',
                name: 'aviso-de-privacidad',
                component: AvisoDePrivacidad
            },
            {
                path: '*', 
                redirect: { name: 'inicio' } 
            }
        ];

        return routes;
    }
}